import type { CategoryInfo } from "@/types";

export const categories: CategoryInfo[] = [
  {
    key: "冒险",
    name: "冒险",
    description: "跨越未知世界与广阔旅程的成长物语，热血与感动并存。",
    icon: "ri-compass-3-line",
    count: 2,
  },
  {
    key: "科幻",
    name: "科幻",
    description: "以未来科技、宇宙探索与机设定为核心的硬核想象世界。",
    icon: "ri-planet-line",
    count: 3,
  },
  {
    key: "恋爱",
    name: "恋爱",
    description: "青涩心跳与命运邂逅，记录青春里最柔软的那段时光。",
    icon: "ri-heart-3-line",
    count: 3,
  },
  {
    key: "校园",
    name: "校园",
    description: "教室、社团与放课后，属于少年少女的日常与悸动。",
    icon: "ri-school-line",
    count: 3,
  },
  {
    key: "热血",
    name: "热血",
    description: "友情、努力与胜利，燃到爆炸的对决与不认输的灵魂。",
    icon: "ri-fire-line",
    count: 3,
  },
  {
    key: "奇幻",
    name: "奇幻",
    description: "魔法、妖怪与异世界，超脱常识的瑰丽幻想舞台。",
    icon: "ri-magic-line",
    count: 4,
  },
  {
    key: "治愈",
    name: "治愈",
    description: "温柔日常与慢节奏叙事，抚慰疲惫心灵的暖意之作。",
    icon: "ri-leaf-line",
    count: 4,
  },
  {
    key: "悬疑",
    name: "悬疑",
    description: "层层反转与缜密推理，带你走进迷雾重重的真相。",
    icon: "ri-mist-line",
    count: 2,
  },
];

export const allCategory = {
  key: "all",
  name: "全部动画",
  description: "汇集站内全部日本动画资源，按热度、评分与年份自由探索。",
};